import { render, staticRenderFns } from "./index--add-form.vue?vue&type=template&id=ffdae398&"
import script from "./index--add-form.vue?vue&type=script&lang=js&"
export * from "./index--add-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports